import VLazyImage from "v-lazy-image/v2/v-lazy-image.es.js";
import { Card, Button } from "@/components";
import { gtmMixin } from "@/mixins";
import mixins from "vue-typed-mixins";
export default mixins(gtmMixin).extend({
    components: {
        Card,
        Button,
        VLazyImage,
    },
    props: {
        name: {
            type: String,
            default: "",
        },
        description: {
            type: String,
            default: "",
        },
        image: {
            type: String,
            default: "",
        },
        url: {
            type: String,
            default: "",
        },
        tutorialUrl: {
            type: String,
            default: "",
        },
        noButton: {
            type: Boolean,
            default: false,
        },
        imgProps: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        trackOnClick() {
            this.gtmClickButton(`${this.image};${this.url};${this.name}`, {});
        },
    },
});
